import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type CreateOrderBody = NonNullable<
  paths['/api/v1/orders']['post']['requestBody']
>['content']['application/json'];
export type CreateOrderResponse =
  paths['/api/v1/orders']['post']['responses'][200]['content']['application/json']['order'];

export async function createOrder(body: CreateOrderBody): Promise<CreateOrderResponse> {
  const { data, error } = await client.POST('/api/v1/orders', {
    body,
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when creating order');
  return data.order;
}
